import { Ban, Undo2 } from 'lucide-react';

/** 🚫 Coin adının yanındaki küçük düğme: bu coine (tüm botlar) işlem açılmasın / tekrar aç. */
export function CoinOffButton({ symbol, offSet, onToggle, busy }) {
    if (!onToggle) return null;
    const off = offSet?.has(symbol);
    const name = symbol.replace('USDT', '');
    return (
        <button type="button" disabled={busy} onClick={(e) => { e.stopPropagation(); onToggle(symbol); }}
                title={off ? `${name} kapalı — tıkla: botlar yine işlem açabilsin` : `${name}'i kapat — sen açana kadar normal bot ve hızlı bot bu coine girmez`}
                className={`inline-flex items-center justify-center h-5 w-5 rounded border transition-colors disabled:opacity-40 ${off ? 'border-rose-500/50 bg-rose-500/15 text-rose-200 hover:bg-rose-500/30' : 'border-slate-700 text-slate-500 hover:text-rose-200 hover:border-rose-500/50'}`}
                data-testid={`coin-off-${symbol}`}>
            {off ? <Undo2 className="h-3 w-3" /> : <Ban className="h-3 w-3" />}
        </button>
    );
}

/** 🚫 Kapalı coinler şeridi — bot panellerinin üstünde; ✕ ile tekrar açılır. */
export function CoinsOffBar({ items = [], onToggle, busy }) {
    if (!items.length) return null;
    return (
        <div className="rounded-md border border-rose-500/30 bg-rose-500/5 px-2.5 py-1.5 text-[11px] text-rose-100 flex flex-wrap items-center gap-1.5" data-testid="coins-off-bar">
            🚫 <b>Kapalı coinler</b> <span className="text-rose-200/70">— sen açana kadar normal bot ve hızlı bot girmez:</span>
            {items.map((i) => (
                <span key={i.symbol} className="inline-flex items-center gap-1 rounded bg-slate-900/60 border border-slate-700 px-1.5 py-0.5" title={`${new Date(i.at * 1000).toLocaleString('tr-TR')} · ${i.note || ''}`} data-testid={`coins-off-chip-${i.symbol}`}>
                    <span className="font-mono font-bold text-slate-50">{i.symbol.replace('USDT', '')}</span>
                    <button type="button" disabled={busy} onClick={() => onToggle(i.symbol)} className="text-slate-400 hover:text-emerald-200 disabled:opacity-40" title="Tekrar aç" data-testid={`coins-off-open-${i.symbol}`}>✕</button>
                </span>
            ))}
        </div>
    );
}
